import React from 'react';
import { Link } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const AccountSidebar = ({ activePage = "profile" }) => {
  const { user, logout } = useAuth();
  
  // Create display name from first and last name
  const displayName = user?.first_name && user?.last_name 
    ? `${user.first_name} ${user.last_name}`.trim()
    : user?.first_name || 'Username';

  const getLinkClassName = (pageName) => {
    const baseClasses = "block w-full text-left px-4 py-3 rounded-lg font-medium border-t border-green-500 transition-colors";
    
    if (activePage === pageName) {
      return `${baseClasses} bg-green-600 text-white`;
    } else {
      return `${baseClasses} text-gray-300 hover:text-white hover:bg-gray-800`;
    }
  };

  return (
    <div className="rounded-l-2xl p-6 text-white" style={{ backgroundColor: '#0a2342' }}>
      {/* User Avatar Section */}
      <div className="text-center mb-8">
        <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
          <FaUserCircle className="w-12 h-12 text-white" />
        </div>
        <div className="font-semibold text-lg">{displayName}</div>
        <div className="text-sm text-gray-300">{user?.email || 'User Email ID'}</div>
      </div>

      {/* Navigation Links */}
      <nav className="space-y-1">
        <Link 
          to="/profile" 
          className={getLinkClassName("profile")}
        >
          Profile
        </Link>
        <Link 
          to="/watchlist" 
          className={getLinkClassName("watchlist")}
        >
          Watchlist
        </Link>
        <Link 
          to="/invoice" 
          className={getLinkClassName("invoice")}
        >
          Invoice
        </Link>
        <Link 
          to="/broker-integrations" 
          className={getLinkClassName("brokers")}
        >
          Broker Integrations
        </Link>
        <Link 
          to="/portfolio" 
          className={getLinkClassName("portfolio")}
        >
          Portfolio
        </Link>
        <Link 
          to="/orders" 
          className={getLinkClassName("orders")}
        >
          Orders
        </Link>
        <Link 
          to="/settings" 
          className={getLinkClassName("settings")}
        >
          Setting
        </Link>
        {(user?.role === 'admin' || user?.role === 'super_admin') && (
          <Link
            to="/admin/shared-zerodha"
            className={getLinkClassName("admin-shared-zerodha")}
          >
            Admin: Shared Zerodha
          </Link>
        )}
        <button 
          onClick={logout}
          className="block w-full text-left px-4 py-3 text-gray-300 hover:text-white hover:bg-gray-800 transition-colors border-t border-green-500"
        >
          Signout
        </button>
      </nav>
    </div>
  );
};

export default AccountSidebar;
